import { Common } from "./Common"
import MouseMgr from "./MouseMgr"
import { OutPutMgr } from "./OutPutMgr"

export default class SceneMain {
    isHide = false;
    constructor(props) {
        this.props = props;
        this.common = new Common({
            wrapper: this.props.$wrapper
        });
        this.mouse = new MouseMgr({
            common: this.common,
            allowCursor: this.props.allowCursor
        });
        this.height = 0;
        this.width = 0;
        this.init();
        this.loop();
        window.addEventListener("resize", this.resize.bind(this))
    }
    init() {
        this.props.$wrapper.appendChild(this.common.renderer.domElement);
        this.output = new OutPutMgr({
            common: this.common,
            mouse: this.mouse,
            allowCursor: this.props.allowCursor
        });
    }
    resize() {
        if(this.isHide)return;
        const {left: e, top: t, width: i, height: s} = this.props.$wrapper.getBoundingClientRect();
        if(!this.props.allowCursor && this.width == i && Math.abs(s - this.height) < 100){
            return;
        }
        // console.log("Math.abs(s - this.height):",Math.abs(s - this.height))
        this.width = i;
        this.height = s;
        this.common.resize();
        this.output.resize();
    }

    setType(type){
        if(type == 1){
            this.output.hideEffect();
        }else{
            this.output.showEffect();
        }
    }
    hide(){
        this.isHide = true;
        this.common.renderer.clear();
    }

    show(){
        this.isHide = false;
        this.resize();
    }
    render() {
        if(this.isHide)return;
        this.mouse.update();
        this.common.update();
        this.output.update();
    }
    maxFps = 45;
    lastTime = 0;
    loop(timeStep) {
        
        const delta = timeStep - this.lastTime;
        if(delta >= 1000/this.maxFps){
            this.render();
            this.lastTime = timeStep;
        }
        
        requestAnimationFrame(this.loop.bind(this))
    }
}